/**
 * GoalInput — the landing hero. Ported from the OnFlow Design System project
 * (components/forms/GoalInput.jsx).
 *
 * Not a search box — this IS the product's front door: one shell, "Goal"
 * label divider, free-text input, ember submit on the right.
 */
import type { ChangeEventHandler, CSSProperties, FormEventHandler } from 'react';

interface GoalInputProps {
  label?: string;
  placeholder?: string;
  submitLabel?: string;
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  style?: CSSProperties;
}

export function GoalInput({
  label = 'Goal',
  placeholder = 'gain 2kg muscle in 23 days',
  submitLabel = 'Continue',
  value,
  onChange,
  onSubmit,
  style,
}: GoalInputProps) {
  return (
    <form
      onSubmit={onSubmit}
      style={{
        display: 'flex',
        alignItems: 'stretch',
        border: '1px solid var(--outline-variant)',
        background: 'var(--surface-container-low)',
        borderRadius: 12,
        maxWidth: 640,
        overflow: 'hidden',
        transition:
          'border-color var(--t-state) var(--ease-out), box-shadow var(--t-state) var(--ease-out)',
        ...style,
      }}
    >
      <label
        htmlFor="onflow-goal"
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 16px 0 24px',
          color: 'var(--on-surface-variant)',
          fontSize: 14,
          borderRight: '1px solid var(--outline-variant)',
        }}
      >
        {label}
      </label>
      <input
        id="onflow-goal"
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="off"
        maxLength={120}
        style={{
          flex: 1,
          minWidth: 0,
          border: 0,
          background: 'transparent',
          padding: '24px 16px',
          fontFamily: 'var(--font-ui)',
          fontSize: 17,
          color: 'var(--on-background)',
          outline: 'none',
        }}
      />
      <button
        type="submit"
        style={{
          background: 'var(--primary)',
          color: 'var(--on-primary)',
          border: 0,
          padding: '0 24px',
          fontFamily: 'var(--font-ui)',
          fontWeight: 500,
          fontSize: 15,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          transition: 'background var(--t-tap) var(--ease-out)',
        }}
      >
        {submitLabel}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M3 8h10M9 4l4 4-4 4" />
        </svg>
      </button>
    </form>
  );
}
